import React, { useState } from 'react';
import {
    Modal,
    ModalOverlay,
    ModalContent,
    ModalHeader,
    ModalFooter,
    ModalBody,
    ModalCloseButton,
    Button,
    Textarea,
    VStack,
    Text,
    HStack,
    useBreakpointValue,
} from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';

const FeedbackModal = ({ isOpen, onClose }: { isOpen: boolean; onClose: (data?: any) => void }) => {
    const [selectedReason, setSelectedReason] = useState<string | null>(null);
    const [comment, setComment] = useState('');
    const { t } = useTranslation();

    const handleReasonSelect = (reason: string) => {
        setSelectedReason(reason);
    };

    const handleSubmit = () => {
        const feedback = {
            reason: selectedReason,
            comment,
        };
        onCloseHandler(comment || selectedReason);
    };

    const onCloseHandler = (data?: any) => {
        onClose(data);
        setSelectedReason(null);
        setComment('');
    };

    const ButtonStack: any = useBreakpointValue({ base: VStack, md: HStack });
    const buttonWidth = useBreakpointValue({ base: "100%", md: "auto" });

    // @ts-ignore
    return (
        <Modal isOpen={isOpen} onClose={() => onCloseHandler()} closeOnOverlayClick={false} size="2xl">
            <ModalOverlay />
            <ModalContent>
                <ModalHeader bg="#ededed" borderRadius="5px 5px 0 0">{t('feedback_modal_title')}</ModalHeader>
                <ModalCloseButton top="4" />
                <ModalBody>
                    <VStack align="stretch" spacing={4}>
                        <Text>
                            {t('feedback_modal_description')}
                        </Text>
                        <ButtonStack spacing={4}>
                            <Button
                                fontWeight="light"
                                fontSize="normal"
                                variant={selectedReason === t('feedback_inappropriate') ? 'brand' : 'outline'}
                                borderColor="#b2b2b2"
                                onClick={() => handleReasonSelect(t('feedback_inappropriate'))}
                                width={buttonWidth}
                            >
                                {t('feedback_inappropriate')}
                            </Button>
                            <Button
                                fontWeight="light"
                                fontSize="normal"
                                variant={selectedReason === t('feedback_not_follow') ? 'brand' : 'outline'}
                                borderColor="#b2b2b2"
                                onClick={() => handleReasonSelect(t('feedback_not_follow'))}
                                width={buttonWidth}
                            >
                                {t('feedback_not_follow')}
                            </Button>
                            <Button
                                fontWeight="light"
                                fontSize="normal"
                                variant={selectedReason === t('feedback_other') ? 'brand' : 'outline'}
                                borderColor="#b2b2b2"
                                onClick={() => handleReasonSelect(t('feedback_other'))}
                                width={buttonWidth}
                            >
                                {t('feedback_other')}
                            </Button>
                        </ButtonStack>
                        <Textarea
                            borderColor="#b2b2b2"
                            placeholder={t('feedback_comment')}
                            value={comment}
                            onChange={(e) => setComment(e.target.value)}
                        />
                    </VStack>
                </ModalBody>
                <ModalFooter>
                    <Button bg="#ededed" color="black" onClick={() => onCloseHandler()} mr="3">
                        {t('feedback_btn_skip')}
                    </Button>
                    <Button variant="brand" onClick={handleSubmit} isDisabled={!selectedReason && !comment}>
                        {t('feedback_btn_submit')}
                    </Button>
                </ModalFooter>
            </ModalContent>
        </Modal>
    );
};

export default FeedbackModal;
